import { render, staticRenderFns } from "./UseStatement.vue?vue&type=template&id=fdfde6a4&scoped=true&"
import script from "./UseStatement.vue?vue&type=script&lang=js&"
export * from "./UseStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfde6a4",
  null
  
)

export default component.exports